export default __webpack_public_path__ + "static/media/A11.77dbdeed.png";